import type { CountryOfPassportListTimezone } from "../countryOfPassportListInterface";

export class CountryOfPassportTimezone {
  name: string;

  timezone: string;

  constructor(data: CountryOfPassportListTimezone) {
    this.name = data.name;
    this.timezone = data.timezone;
  }
}
